const getLastPartTimestamp = (store) => {
  return store.lastPartTimestamp;
};

export { getLastPartTimestamp };
